import request from './request';
// ====================== 1. 联系我们相关接口 ======================
const ContactUsAPI = {
  /**
   * 获取总部联系信息
   * @returns {Promise<Object>} ContactInfo 对象
   */
  getHeadquarters: () => request('/contact-us/headquarters'),

  /**
   * 获取所有联系信息
   * @returns {Promise<Array>} ContactInfo 列表
   */
  getAllContacts: () => request('/contact-us/all')
};

// ====================== 2. 招贤纳士相关接口 ======================
const TalentRecruitmentAPI = {
  /**
   * 获取招贤纳士基础信息
   * @param {string} categoryFilter 分类过滤（all/work/live），默认 all
   * @returns {Promise<Object>} 包含 workInXinghan/liveInXinghan 字段的对象
   */
  getBasicInfo: (categoryFilter = 'all') =>
    request('/talent-recruitment/basic', { categoryFilter }),

  /**
   * 获取职位列表（分页+筛选）
   * @param {Object} params 筛选参数
   * @param {number} params.page 页码，默认 1
   * @param {number} params.size 每页条数，默认 10
   * @param {string} params.department 部门筛选（模糊匹配），默认 -
   * @param {string} params.location 工作地点筛选，默认 -
   * @param {string} params.status 职位状态（open/closed），默认 open
   * @returns {Promise<Object>} 分页数据（records/total/current/size）
   */
  getPositions: (params = {}) =>
    request('/talent-recruitment/positions', {
      page: params.page || 1,
      size: params.size || 10,
      department: params.department || '-',
      location: params.location || '-',
      status: params.status || 'open'
    })
};

// ====================== 3. 新闻列表 ======================
const NewsAPI = {
  /**
   * 获取内容列表（分页）
   * @param {Object} params 筛选参数
   * @param {number} params.current 页码，默认 1
   * @param {number} params.size 每页条数，默认 3
   * @param {number} params.categoryId 分类ID，默认 -
   * @returns {Promise<Object>} 分页数据（records/total/current/size/pages）
   */
  getContentList: (params = {}) =>
    request('/content/list', {
      current: params.current || 1,
      size: params.size || 3,
      categoryId: params.categoryId || '-'
    }),

  /**
   * 获取内容详情
   * @param {number} id 内容ID（必填）
   * @returns {Promise<Object>} ContentDetailDTO 对象
   */
  getContentDetail: (id) => {
    console.log(99999,id);
    if (!id) throw new Error('内容ID不能为空');
    return request(`/content/${id}`);
  }
};

// ====================== 4. 解决方案相关接口 ======================
const SolutionAPI = {
  /**
   * 获取解决方案列表（分页）
   * @param {Object} params 筛选参数
   * @param {number} params.current 页码，默认 1
   * @param {number} params.size 每页条数，默认 4
   * @param {number} params.categoryId 分类ID，默认 -
   * @returns {Promise<Object>} 分页数据（records/total/current/size/pages）
   */
  getSolutionList: (params = {}) =>
    request('/solution/list', {
      current: params.current || 1,
      size: params.size || 4,
      categoryId: params.categoryId || '-'
    }),

  /**
   * 获取解决方案详情
   * @param {number} id 解决方案ID（必填）
   * @returns {Promise<Object>} SolutionDetailDTO 对象
   */
  getSolutionDetail: (id) => {
    if (!id) throw new Error('解决方案ID不能为空');
    return request(`/solution/${id}`);
  },

  /**
   * 获取产品详情
   * @param {number} id 产品ID（必填）
   * @returns {Promise<Object>} Product 对象
   */
  getProductDetail: (id) => {
    if (!id) throw new Error('产品ID不能为空');
    return request(`/solution/product/${id}`);
  }
};

// ====================== 5. 科研实力相关接口 ======================
const RDAPI = {
  /**
   * 获取所有科研实力数据
   * @returns {Promise<Object>} 包含 famousUniversities/patentCertifications 的对象
   */
  getAllResearchData: () => request('/research-strength'),

  /**
   * 获取知名高校展示数据
   * @returns {Promise<Array>} Image 列表
   */
  getFamousUniversities: () => request('/research-strength/famous-universities'),

  /**
   * 获取专利认证展示数据
   * @returns {Promise<Array>} Image 列表
   */
  getPatentCertifications: () => request('/research-strength/patent-certifications')
};

// ====================== 6. 关于我们相关接口 ======================
const AboutAPI = {
  /**
   * 获取所有关于我们数据
   * @returns {Promise<Object>} AboutData 对象
   */
  getAllAboutData: () => request('/about'),

  /**
   * 获取合作共赢展示数据
   * @returns {Promise<Array>} Image 列表
   */
  getCooperationPartners: () => request('/about/cooperation-partners'),

  /**
   * 获取资质荣誉展示数据
   * @returns {Promise<Array>} Image 列表
   */
  getQualificationHonors: () => request('/about/qualification-honors'),

  /**
   * 获取关于我们的内容
   * @returns {Promise<Object>} SinglePage 对象
   */
  getAboutContent: () => request('/about/about-content'),

  /**
   * 获取发展历程内容
   * @returns {Promise<Array>} DevelopmentHistory 列表
   */
  getDevelopmentHistories: () => request('/about/development-histories')
};

// ====================== 7. 首页相关接口 ======================
const HomeAPI = {
  /**
   * 获取所有首页数据
   * @returns {Promise<Object>} HomeData 对象
   */
  getAllHomeData: () => request('/home'),

  /**
   * 获取知名企业展示数据
   * @returns {Promise<Array>} Image 列表
   */
  getFamousEnterprises: () => request('/home/famous-enterprises'),

  /**
   * 获取新闻内容模块数据（最多6条）
   * @returns {Promise<Array>} Content 列表
   */
  getHomeNews: () => request('/home/news'),

  /**
   * 获取首页总部联系信息
   * @returns {Promise<Object>} ContactInfo 对象
   */
  getHomeContact: () => request('/home/contact')
};

// 默认导出

export {
  ContactUsAPI, 
  TalentRecruitmentAPI, 
  NewsAPI,
  SolutionAPI,
  RDAPI,
  AboutAPI,
  HomeAPI
};

// ES6 模块导出（支持 Vue/React 等框架）
export default {
  ContactUsAPI, 
  TalentRecruitmentAPI, 
  NewsAPI,
  SolutionAPI,
  RDAPI,
  AboutAPI,
  HomeAPI
};